import { client as defaultClient } from '@up2stay/up2promo-api-client';
import { stripTrailingSlash } from '@up2stay/up2promo-commons/auth';

import { env } from '../env';
import { detectBrowserLocale } from '../utils/locale.utils';

// Guard to ensure initialization only happens once
let isInitialized = false;

/**
 * Initialize the API client with the base URL from environment variables.
 * This runs synchronously at module load time to ensure the client is always ready
 * before any API calls are made.
 *
 * This is a singleton pattern - initialization only happens once, even if this
 * module is imported multiple times.
 */
function initializeApiClient() {
  if (isInitialized) {
    return;
  }

  // Configure the baseURL from environment variables. The language header matches
  // app/admin (`x-custom-lang`) so localized responses (e.g. Google Places) follow the UI.
  const baseURL = stripTrailingSlash(env.VITE_API_URL);
  defaultClient.setConfig({
    baseURL,
    headers: { 'x-custom-lang': detectBrowserLocale() },
  });

  isInitialized = true;
}

// Initialize immediately at module load time (synchronous)
// This ensures the client is always ready before any API calls
initializeApiClient();

/**
 * Export the initialized client for direct use if needed.
 * Most API calls use the default client from '@up2stay/up2promo-api-client' directly,
 * which is already configured with baseURL via initializeApiClient().
 */
export { defaultClient as client };
